import { useMemo } from "react";

export function useWechat() {
  const isWechat = useMemo(() => {
    if (typeof window !== 'undefined') {
      const ua = window.navigator.userAgent.toLowerCase();
      const isWXWork = ua.includes('wxwork');
      const isWeixin = !isWXWork && ua.includes('micromessenger');
      return isWeixin;
    }
    return false;
  }, []);
  return { isWechat }
}